module.exports = __webpack_public_path__ + "static/img/pic_bimg.d29e4e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_bimg.jpg
// module id = y/JS
// module chunks = 34